import { useContext } from "react";
import { AppContext } from "../components/app/app-context";
import { AppContextValue, FeatureFlagProviderName, TextTemplateKey } from "../components/types";

/**
 * This hook is a convenience hook for consuming the AppContext.
 *
 * Particularly, it allows users of the library to call this hook with an application specific TS Type for the
 * TextTemplateKey type. This sets up the `localizedText` helper function with the application specific TextTemplateKey
 * set thus providing useful code completion hints when using this function.
 *
 * @deprecated Use the new individual Context Providers and their companion custom hooks.
 */
export const useAppContext = <
  T extends TextTemplateKey,
  C extends object,
  F extends FeatureFlagProviderName
>(): AppContextValue<T, C, F> => {
  return useContext(AppContext) as AppContextValue<T, C, F>;
};
